/**
 * Transforms an object with snake_case keys to camelCase
 *
 * @param {any} o Object to transform
 * @returns
 */
function toCamelCase(o: { [key: string]: any }): { [key: string]: any } {
  let newO: { [key: string]: any } = {};
  for (let key in o) {
    if (o.hasOwnProperty(key)) {
      let newKey = key.replace(/(_\w)/g, match => match[1].toUpperCase());
      newO[newKey] = o[key];
    }
  }
  return newO;
}

export default toCamelCase;
